var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { dateTime } from "@gravity-ui/date-utils";
import { GameUserRole, GameUserStatus, } from "@/store/api";
import { parseEmptyString } from "@/tools/parse";
/** Модель игрока для игры */
export var convertGameUserToViewModel = function (data) {
    return {
        status: [data.status || GameUserStatus.Invited],
        userName: data.userName,
        userId: data.userId,
        role: data.role || GameUserRole.Member,
    };
};
/** Модель игры */
export var convertGameToViewModel = function (data) {
    return __assign(__assign({}, data), { placeId: [data.place.id], sportId: data.sport ? [data.sport.id] : [], date: data.date ? dateTime({ input: data.date }) : dateTime(), gameUsers: data.gameUsers.map(convertGameUserToViewModel), level: [data.level], requestMode: data.requestMode, countMembersMax: parseEmptyString(data.countMembersMax), countMembersMin: parseEmptyString(data.countMembersMin), description: parseEmptyString(data.description) });
};
